<template>
  <section
    ref="container"
    class="page-container">
    <div
      class="main-header ">
      <div
        v-if="!isAccount"
        class="flex-sb">
        <div class="">

          <div class="header-title flex">
            <template>
              <span
                class="icon color-gray"
              >
                <font-awesome-icon icon="people-group" />
              </span>
            </template>
            <h3>{{ teamLeaderData.name }}</h3>
          </div>
          <div class="mg-b-8">
            <span class="header-date">Created  <span class="number-color number-fontsize">{{ teamLeaderData.created_at }}</span></span>
            <span class="header-date">Last Login  <span class="number-color number-fontsize">{{ teamLeaderData.last_login }}</span></span>
          </div>
        </div>
      </div>
      <el-tabs
        v-model="activeTab"
      >
        <el-tab-pane
          v-for="(item, index) in month"
          :key="index"
          :name="item.quarter"
        >
          <span slot="label">
            <span>
              <font-awesome-icon
                class="icon"
                icon="bullseye"></font-awesome-icon>
              <span>{{item.value}}</span>
            </span>
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      class="main-container">
      <div
        class="main-col">
        <div class="middle-col">

          <div class="show-data__container">
            <span class="title">Quarterly Settlement Date <span class="date">{{quarter_data.value}}</span></span>
            <template v-if="summary.is_top_team_head">
              <div>
                <span class="flex-sb-center mg-t-30 mg-b-8">
                  <span class="fs-12 color-gray fw-600 flex-align-center"><font-awesome-icon
                    icon="user"
                    class="mg-r-3 icon-16"></font-awesome-icon><span >Invited Members</span></span>
                  <span class="color-gray fs-12 fw-600 flex-align-center">
                    <font-awesome-icon
                      icon="dollar-sign"
                      class="mg-r-3 icon-16"></font-awesome-icon><span>Incentive</span>
                  </span>
                </span>
                <span class="flex-sb-center mg-b-8">
                  <span class="block fs-16 color-dark fw-600">{{summary.invited_members}}</span>
                  <span class="block fs-16 color-green fw-600">{{invited_members_premium|formatMoney(2,false)}}</span>
                </span>
                <div class="progress-bar">
                  <el-progress
                    :text-inside="false"
                    :stroke-width="12"
                    :percentage="member_percentage"
                    :stroke-linecap="'square'"
                    :define-back-color="'#DCFFE4'"
                    :color="'#28A745'"
                    :format="format"
                  ></el-progress>
                </div>
                <div class="progress-bar_up flex">
                  <span class="box-icon" >
                    <font-awesome-icon
                      class="color-gray  fs-14"
                      :class="{'color-green':summaryMember(100)}"
                      icon="caret-up"></font-awesome-icon>
                  </span>
                  <span class="box-icon">
                    <font-awesome-icon
                      class="color-gray  fs-14"
                      :class="{'color-green':summaryMember(300)}"
                      icon="caret-up"></font-awesome-icon>
                  </span>
                  <span class="box-icon">
                    <font-awesome-icon
                      class="color-gray  fs-14"
                      :class="{'color-green':summaryMember(500)}"
                      icon="caret-up"></font-awesome-icon>
                  </span>
                </div>
                <div class="member-box">
                  <span
                    v-for="(item,index) in memberUserList"
                    :key="'m_use_'+index"
                    class="box-container"
                    :class="{'bg-color-green':summaryMemberOver(item.user,item.over)}">
                    <div
                      class="fs-12 color-gray fw-600 flex-align-center box-content">
                      <span class="mg-r-8">
                        <font-awesome-icon
                          icon="user"
                          class="mg-r-3 icon-16"></font-awesome-icon><span >{{item.user}}</span>
                      </span>
                      <span>
                        <font-awesome-icon
                          icon="dollar-sign"
                          class="mg-r-3 icon-16"></font-awesome-icon><span>{{item.money}}</span>
                      </span>
                    </div>
                  </span>

                </div>
              </div>
              <div>
                <span class="flex-sb-center mg-t-30 mg-b-8">
                  <span class="fs-12 color-gray fw-600 flex-align-center"><font-awesome-icon
                    icon="coins"
                    class="mg-r-3 icon-16"></font-awesome-icon><span >Issued GWP</span></span>
                  <span class="color-gray fs-12 fw-600 flex-align-center">
                    <font-awesome-icon
                      icon="dollar-sign"
                      class="mg-r-3 icon-16"></font-awesome-icon><span>Incentive</span>
                  </span>
                </span>
                <span class="flex-sb-center  mg-b-8">
                  <span class="block fs-16 color-dark fw-600">{{summary.issued_premium|formatMoney(2,true)}}</span>
                  <span class="block fs-16 color-green fw-600">{{gwp_premium|formatMoney(2,false)}}</span>
                </span>
                <div class="progress-bar">
                  <el-progress
                    :text-inside="false"
                    :stroke-width="12"
                    :percentage="gwp_percentage"
                    :stroke-linecap="'square'"
                    :define-back-color="'#DCFFE4'"
                    :color="'#28A745'"
                    :format="format"
                  ></el-progress>
                </div>
                <div class="progress-bar_up_gwp flex">
                  <span
                    class="box-icon"
                  >
                    <font-awesome-icon
                      class="color-gray  fs-14"
                      :class="{'color-green':isGwpOver(0.5)}"
                      icon="caret-up"></font-awesome-icon>
                  </span>
                  <span
                    class="box-icon"
                  >
                    <font-awesome-icon
                      class="color-gray  fs-14"
                      :class="{'color-green':isGwpOver(1)}"
                      icon="caret-up"></font-awesome-icon>
                  </span>
                  <span
                    class="box-icon"
                  >
                    <font-awesome-icon
                      class="color-gray  fs-14"
                      :class="{'color-green':isGwpOver(3)}"
                      icon="caret-up"></font-awesome-icon>
                  </span>
                </div>
                <div class="member-box gwp_box">
                  <span
                    v-for="(item,index) in gwpList"
                    :key="'gwp_'+index"
                    :class="{'bg-color-green':summaryGWPOver(item.gwp,item.over)}"
                    class="box-container">
                    <div
                      class="fs-12 color-gray fw-600 flex-align-center box-content">
                      <span class="mg-r-8">
                        <font-awesome-icon
                          icon="coins"
                          class="mg-r-3 icon-16"></font-awesome-icon><span >{{item.gwp}} M</span>
                      </span>
                      <span>
                        <font-awesome-icon
                          icon="dollar-sign"
                          class="mg-r-3 icon-16"></font-awesome-icon><span>{{item.money}}</span>
                      </span>
                    </div>
                  </span>

                </div>
              </div>
            </template>
          </div>
          <div class="show-data__container">
            <span class="title fs-16 color-dark fw-600">Quarter Summary</span>
            <ul>
              <li>
                <p>Total Members</p>
                <p>{{summary.total_members}}</p>
              </li>
              <li>
                <p>Total Policy # (Total premium)</p>
                <p>{{summary.policy_num}} </p>
                <p class="color-gray mg-b-0">{{summary.premium|formatMoney(2,true)}}</p>
              </li>
              <li>
                <p>Hold Dollars Reward</p>
                <p>{{summary.hold_dollars|formatMoney(2,true)}}</p>
                <!--                <p class="color-gray mg-b-0">{{summary.premium|formatMoney(2,true)}}</p>-->
              </li>
            </ul>
          </div>
          <div class="detail">
            <div class="table">
              <div class="tr th">
                <span>Team Member</span>
                <span>Policy#</span>
                <span>Total GWP</span>
              </div>
              <template v-if="tableData.length>0||team_head_data">
                <div
                  v-if="team_head_data"
                  class="tr"
                  :class="{'trans_bg':tableData.length<=0}"
                >
                  <span  class="summary_tr">
                    <div class="flex">
                      <p class="icon-user">
                        <font-awesome-icon
                          icon="user"></font-awesome-icon>
                      </p>
                      <span>
                        <span>{{team_head_data.name}}</span>
                        <span class="tr_contact">{{team_head_data.contact}}</span>
                      </span>
                    </div>
                  </span>
                  <span  class="summary_tr">{{team_head_data.policy_num}}</span>
                  <span  class="summary_tr">{{team_head_data.premium|formatMoney(2,false)}}</span>
                </div>
                <div
                  v-for="(item,index) in tableData"
                  :key="'table_tr'+index"
                  class="tr_table">
                  <div class="tr">
                    <span class="summary_tr">
                      <div class="flex">
                        <p class="icon-user">
                          <font-awesome-icon
                            icon="user"></font-awesome-icon>
                        </p>
                        <span>
                          <span>{{item.name}}</span>
                          <span class="tr_contact">{{item.contact}}</span>
                        </span>
                      </div>
                    </span>
                    <span  class="summary_tr">{{item.all_policy_num}}</span>
                    <span  class="summary_tr">{{item.all_premium | formatMoney(2, false)}}</span>
                    <span
                      v-if="item.is_next"
                      class="summary_tr icon">
                      <font-awesome-icon
                        v-if="!item.is_open"
                        icon="square-plus"
                        class="icon pointer"
                        @click="handleOpen(item,index)"></font-awesome-icon>
                      <font-awesome-icon
                        v-else
                        icon="square-minus"
                        class="icon pointer"
                        @click="handleOpen(item,index)"></font-awesome-icon>
                    </span>
                  </div>
                  <div
                    v-if="item.is_open"
                    class="tr_more_detail">
                    <div class="tr_contact">{{item.team_members.members}} Members</div>
                    <div>
                      <div>
                        <span  class="tr">
                          <span class="flex">
                            <p class="icon-user">
                              <font-awesome-icon icon="user"></font-awesome-icon>
                            </p>
                            <span>
                              <span>{{item.team_members.name}}</span>
                              <span class="tr_contact">{{item.team_members.contact}}</span>
                            </span>
                          </span>
                          <span  class="summary_tr ">{{item.team_members.policy_num}}</span>
                          <span  class="summary_tr">{{item.team_members.premium|formatMoney(2,false)}}</span>
                        </span>
                        <div
                          v-for="(sec_item,sec_index) in item.team_members.items"
                          :key="'sec_item_'+sec_index"
                          class="tr_second">
                          <div >
                            <div class="tr ">
                              <span>
                                <span class="flex">
                                  <p class="icon-user">
                                    <font-awesome-icon icon="user-group"></font-awesome-icon>
                                  </p>
                                  <span>
                                    <span>{{sec_item.name}}</span>
                                    <span class="tr_contact">{{sec_item.contact}}</span>
                                  </span>
                                </span>
                              </span>
                              <span  class="summary_tr mg-left-15">{{sec_item.policy_num}}</span>
                              <span  class="summary_tr">{{sec_item.premium|formatMoney(2,false)}}</span>
                            </div>
                          </div>
                          <div
                            v-for="(third_item,third_index) in sec_item.items"
                            :key="'third_item'+third_index"
                            class="tr_third">
                            <div class="tr">
                              <span>
                                <span class="flex">
                                  <p class="icon-user">
                                    <font-awesome-icon icon="users"></font-awesome-icon>
                                  </p>
                                  <span>
                                    <span>{{third_item.name}}</span>
                                    <span class="tr_contact">{{third_item.contact}}</span>
                                  </span>
                                </span>
                              </span>
                              <span  class="summary_tr mg-left-30">{{third_item.policy_num}}</span>
                              <span  class="summary_tr">{{third_item.premium|formatMoney(2,false)}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div
                  class="tr none_border">
                  <span  class="summary_tr">
                  </span>
                  <span class="el-table__empty-text">No Data</span>
                  <span  class="summary_tr"></span>
                </div>
              </template>
            </div>
            <v-pagination
              :total="pageConfig.total"
              :current="pageConfig.currentPage"
              @currentChange="currentChange" />
          </div>
        </div>
        <div
          v-if="!isAccount"
          class="right-col">
          <div class="">
            <div
              class="box">
              <span class="title">Team Leader</span>
              <div>
                <div class="flex flex-align-center">
                  <div class="customer-ava">
                    <img
                      :src="avt_pic"
                      alt="">
                  </div>
                  <span class="span-status">{{customer_profile.id_type==3?'Company':'Personal'}}</span>
                  <router-link
                    :to="{path:'/accounts/detail',query:{customer_id:customer_profile.id}}"
                    class="flex flex-wrap text-decoration-none">
                    <span
                      v-if="isShowName"
                      class="plan-name hand"
                    >{{ customer_profile.cs_name }} &nbsp;</span>
                    <span
                      v-else
                      class="plan-name hand unname"
                    >Unnamed Account &nbsp;</span>
                  </router-link>
                </div>
                <ul>
                  <li>
                    <span>Joined</span>
                    <span>{{ customer_profile.created_at }}</span>
                  </li>
                  <li>
                    <span>Policy Count</span>
                    <span>{{ customer_profile.policys }}</span>
                  </li>
                  <li>
                    <span>Tags</span>
                    <span>
                      <div
                        v-if="customer_profile.upload_request_stts == 1 || customer_profile.is_tier_base || customer_profile.referral_coupon || customer_profile.referral_discount"
                        class="tag">
                        <div
                          v-if="customer_profile.upload_request_stts == 1"
                          class="span-tag unread-uplod">Unread Upload</div>
                        <div
                          v-if="customer_profile.is_tier_base"
                          class="span-tag professional-status">Professional</div>
                        <div
                          v-if="customer_profile.referral_coupon"
                          class="span-tag coupon-status">Custom Coupon</div>
                        <div
                          v-if="customer_profile.referral_discount"
                          class="span-tag discount-status">Custom Discount</div>
                      </div>

                      <div
                        v-if="customer_profile.verify_language"
                        class="tag">
                        <div
                          class="span-tag"
                          :class="{
                            'verified': customer_profile.verified == 20,
                            'pending_verify ': customer_profile.verified == -1,
                            'not_verify': customer_profile.verified == -2
                          }">{{ customer_profile.verify_language }}</div>
                      </div>

                      <div
                        v-if="customer_profile.is_flagged"
                        class="tag">
                        <div class="span-tag unread-uplod">
                          Flagged
                        </div>
                      </div>
                      <div
                        v-if="has_block_data"
                        class="tag">
                        <div class="span-tag not_verify">
                          Blocked
                        </div>
                      </div>
                    </span>
                  </li>
                </ul>
              </div>
              <contact-customer
                :customerId="customer_profile.id"
                :phone="customer_profile.phone"
                :customerName="customer_profile.cs_name"
                :email="customer_profile.send_email" />
            </div>
          </div>
          <div class="box box-remark">
            <span class="title">Remarks</span>
            <div class="remarks-container">
              <div
                v-for="(item, index) in remarkList"
                :key="index"
                class="remark-box">
                <div class="remark-header">
                  <span>{{ item.cs_name }}</span>
                  <span>{{ item.created_at }}</span>
                </div>
                <p>{{ item.message }}</p>
              </div>
            </div>
            <div class="remark-add">
              <v-input
                v-model="message"
                class="mg-b-15"
                append="Add"
                @handlerAppend="handlerSendRemark"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import ContactCustomer from '@/views/components/new-contact-customer'
import {getQuarterMonthList} from '@api/referBonus'
import {getSpecialReferrerSummary,getSpecialReferrerList,getSpecialReferrerDetail } from '@api/incentiveBonus'
import {addAccountRemark, getAccountDetail} from '@api/account'

export default {
  name: 'ReferBonusDetail',
  components:{
    ContactCustomer,
  },
  mixins: [MixinOptions,MixinFormat],
  props:{
    isAccount:{
      type:Boolean,
      default:false
    },
    customerId: [String, Number],
  },
  data () {
    return {
      progress: 0,
      detailData: {},
      isShow:false,
      message: '',
      remarkList: [],
      tableData:[],
      search:'',
      stts:0,
      pageConfig:{
        total: 0,
        currentPage: 1
      },
      activeTab:'',
      summary:{},
      month:[],
      customer_profile:{},
      expandedRows: [], // 存储展开的行的唯一标识
      team_head_data:{}
    }
  },
  computed:{
    ...mapState('referBonus',['teamLeaderData']),
    id(){
      if(this.isAccount)
        return  this.customerId
      return this.$route.params.id
    },
    sttsList(){
      return [
        {id:0,name:'All'},
        {id:1,name:'Active'},
        {id:2,name:'None Active'},
      ]
    },
    quarter_data(){
      let arr =  this.month.filter(item=>item.quarter==this.activeTab)
      return arr[0]||{}
    },
    isShowName(){
      let {cs_name,isrd_lst_nm,isrd_fst_nm} = this.customer_profile
      if(cs_name)
        return cs_name.trim()!=''
      else return  false
    },
    has_block_data(){
      let {block_data=[]} = this.customer_profile||{}
      return block_data.length>0
    },
    selectData(){
      return [this.id]
    },
    avt_pic(){
      let {avatar_thumb_url} = this.customer_profile||{}
      return avatar_thumb_url || null
    },
    memberUserList() {
      return [
        {
          user:100,
          money:'4,000',
          over:300
        },
        {
          user:300,
          money:'15,000',
          over:500
        },
        {
          user:500,
          money:'30,000'
        },
      ]
    },
    gwpList() {
      return [
        {
          gwp:0.5,
          money:'10,000',
          over:1
        },
        {
          gwp:1,
          money:'25,000',
          over:2
        },
        {
          gwp:3,
          money:'100,000'
        },
      ]
    },
    invited_members_premium(){
      let {invited_members} = this.summary||{}
      if(invited_members>=100&&invited_members<300){
        return 4000
      }
      if(invited_members>=300&&invited_members<500){
        return 15000
      }
      if(invited_members>=500){
        return 30000
      }
      return 0
    },
    gwp_percentage(){
      let {issued_premium} = this.summary||{}
      let total = 3*1000000
      return (issued_premium/total)*100||0
    },
    gwp_premium(){
      let {issued_premium} = this.summary||{}
      if(issued_premium>=(0.5*1000000)&&issued_premium<1000000){
        return 10000
      }
      if(issued_premium>=1000000&&issued_premium<3*1000000){
        return 250000
      }
      if(issued_premium>=3*1000000){
        return 100000
      }
      return 0
    },
    member_percentage(){
      let total = 500
      let {invited_members} = this.summary||{}
      return (invited_members/total)*100||0
    },
    summaryMember(){
      return (val)=>{
        let {invited_members} = this.summary||{}
        if(invited_members>=val)
          return true
        return false
      }
    },
    summaryMemberOver(){
      return (val,over)=>{
        let {invited_members} = this.summary||{}
        if(invited_members>=val&&invited_members<over)
          return true
        return false
      }
    },
    isGwpOver(){
      return (val)=>{
        let {issued_premium} = this.summary||{}
        if(issued_premium>=(val*1000000))
          return true
        return false
      }
    },
    summaryGWPOver(){
      return (val,over)=>{
        let {issued_premium} = this.summary||{}
        if(issued_premium>=(val*1000000)&&issued_premium<over*1000000)
          return true
        return false
      }
    }
  },
  watch:{
    activeTab:{
      immediate:true,
      async handler(val){
        if(val!=0&&val){
          await this.network().getQuarterSummary()
          this.network().getDetailQuarterList()
        }
      }
    }
  },

  async mounted(){
    await this.network().getQuarterMonthList()
    if(!this.isAccount)
      await this.network().getAccountDetail()
  },
  methods: {
    async handleOpen(item,index){
      let {team_head,team_members,is_open} = item||{}
      if(team_members){
        this.tableData[index].is_open = !is_open
      }else
        await this.network().getSpecialReferrerDetail({team_head},index)
    },
    format() {
      return ''
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.network().getDetailQuarterList()
    },
    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getDetailQuarterList()
    },
    handleRefresh(){
      this.network().getHanbergDetail()
    },
    handlerSendRemark(){
      if(this.message){
        this.network().addRemark()
      }
    },
    network(){
      return{
        getDetailQuarterList: async () => {
          const {data} = await getSpecialReferrerList({
            user_id: this.id,
            quarter:this.activeTab,
            page:this.pageConfig.currentPage
          })
          this.pageConfig.currentPage = data.current_page
          this.pageConfig.total = data.total
          this.tableData = data.data||[]
          this.tableData.reduce((res,item)=>{
            item.is_open = false
            res.push(item)
            return res
          },[])
          let {team_head_data} = data
          this.team_head_data = team_head_data
        },
        getSpecialReferrerDetail: async (params,index) => {

          let table = JSON.parse(JSON.stringify(this.tableData))
          const {data} = await getSpecialReferrerDetail({
            user_id: this.id,
            quarter:this.activeTab,
            ...params,
            // hideLoading:true
          })
          table[index].team_members = data||{}
          table[index].is_open = true
          // this.tableData = []
          setTimeout(()=>{
            this.tableData = table
          },100)
        },
        getQuarterMonthList: async () => {
          const {data} = await getQuarterMonthList({
          })
          this.month = data
          let {quarter} = data[0]||{}
          this.activeTab = quarter||''
        },
        getQuarterSummary: async () => {
          let {quarter} = this.quarter_data||{}
          const {data} = await getSpecialReferrerSummary({
            user_id: this.id,
            quarter:this.activeTab
          })
          this.summary = data
        },
        getAccountDetail: async () => {
          const {data} = await getAccountDetail({
            customer_id: this.id
          })
          this.customer_profile = data.customer_profile
          this.remarkList = data.remark

        },
        addRemark: async () => {
          const {data} = await addAccountRemark({
            customer_id: this.id,
            message: this.message
          })
          this.message = ''
          this.remarkList.unshift(data)
        },

      }
    }
  },
}
</script>
<style lang='scss' scoped>
@import '../../../../assets/css/pay-main-header';
.page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  min-height: 100%;
  padding-bottom: 40px;
  box-sizing: content-box;
  .row-flex{
    display: flex;
    flex-direction: column;
    min-width: 36px;
    margin-right: 8px;
    &:last-child{
      margin-right: 0;
    }

  }
  .flex-1{
    margin-right: 15px;
    &:last-child{
      margin-right: 0;
    }
  }
  .hand{
    cursor:pointer;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style:italic;
    font-weight: normal!important;
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
  .top-bar {
    padding-top: 5px;
    color: #e6a23d;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #e6a23d;
  }

  .span-status{
    color: #fff;
    padding: 1px 8px;
    border-radius: 100px;
    margin-right: 15px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }
  .yellow{
    background-color: #DBAB09;
  }
  .red{
    border: 1px solid #CB2431;
    background: #fff;
    color: #D73A49;
  }
  .black{
    border: 1px solid #6A737D;
    background: #fff;
    color: #24292E;
  }
  .purple{
    background-color: #6F42C1;
  }
  .green{
    background: #28A745;
    color: white!important;
  }
  .orange {
    background: #E36209;
  }
  .void{
    background: #d73a49;
  }
  .main-container {
    padding: 0 88px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0 auto;
    // max-width: 100%;
    // overflow: auto;
    .detail_title{
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      display: flex;
      align-items: center;
      color: #24292E;
      margin-bottom: 20px;
    }
    .left-col {
      margin-right: 15px;
      width: 250px;
      color: #616266;

      .title {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }

      .name {
        display: block;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
      }

      .label {
        display: inline-block;
        margin: 10px 0;
        font-size: 14px;
        color: #616266;
        font-weight: 500;
      }

      .el-button {
        margin-top: 20px;
      }



      .info-container {
        margin: 10px -15px 0 -15px;
        padding: 0 15px 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;

        .plan-info-box {
          .logo {
            width: 80px;
            height: 45px;

            img {
              max-width: 80px;
              max-height: 45px;
            }
          }

          p {
            padding-left: 10px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: #616266;
          }
        }

        .info-box {
          margin: 5px 0 0 0;
          color: #616266;

          & > div:last-child {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .main-col {
      flex: 1;
      display: flex;
    }

    .main-edit {
      .top-header {
        display: flex;

        .card:last-child {
          margin-left: 15px;
          width: 250px;
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }
      }
    }
    .buy-quote-container{
      flex: 1;
    }
    .middle-col {
      flex: 1;
      min-width: 600px;
      .show-data__container{
        margin-bottom: 20px;
        .color-green{
          color:#22863A;
        }
        .mg-t-30{
          margin-top: 30px;
        }
        .icon-16{
          font-size: 16px!important;
          width: 16px;
        }
        .title{
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #586069;
          display: inline-block;
          .date{
            margin-left: 8px;
            display: inline-block;
            font-weight: 400;
            color: #24292E;
          }
          &.color-dark{
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px;
            color: #24292E;
          }
        }
        ul{
          display: flex;
          margin-top: 20px;
          li{
            list-style: none;
            flex: 1;
            background: #F6F8FA;
            border: 1px solid #E1E4E8;
            border-radius: 6px;
            margin-right: 15px;
            padding: 16px;
            display: flex;
            flex-direction: column;
            //justify-content: space-between;
            &:last-child{
              margin-right: 0;
            }
            &.green{
              background: #DCFFE4;
              border: 1px solid rgba(23, 111, 44, 0.2);
            }
            &.red{
              background: #FFE3E6;
              border: 1px solid rgba(158, 28, 35, 0.2);            }
            p{
              font-weight: 600;
              font-size: 12px;
              line-height: 18px;
              color: #586069;
              margin-bottom: 10px;
              &:nth-child(2){
                font-weight: 600;
                font-size: 16px;
                line-height: 24px;
                margin-bottom: 0;
                color: #24292E;
              }
              &.mg-b-0{
                margin-bottom: 0;
              }
            }
          }
        }
        .progress-bar{
          /deep/.el-progress-bar{
            padding-right: 0;
            .el-progress-bar__outer{
              background: #DCFFE4;
              border-radius: 0;
              .el-progress-bar__inner{
                border-radius: 0;
              }
            }
          }
        }
        .member-box{
          display: flex;
          justify-content: space-between;
          //margin-top: 20px;
          .box-container{
            width: calc(33.3% - 4px);
            .box-content{
              background: $gray;
              padding: 4px 8px;
              justify-content: center;
            }
          }
        }
        .progress-bar_up{
          text-align: end;
          .box-icon{
            &:first-child{
              width: 20%;
            }
            &:nth-child(2){
              width: 40%;
            }
            &:nth-child(3){
              width: 40%;
            }
          }
        }
        .progress-bar_up_gwp{
          text-align: end;
          .box-icon{
            &:first-child{
              width: 16.7%;
            }
            &:nth-child(2){
              width: 16.8%;
            }
            &:nth-child(3){
              width: 66.7%;
            }
          }
        }
      }
      .card {
        margin-bottom: 15px;
      }

      .draft-container {
        padding: 10px;
        background: #91939A;
        border-radius: 4px;
        color: white;

        span {
          display: block;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
          color: white;
        }

        .msg {
          padding: 5px 0;
          font-size: 14px;
        }
      }
    }

    .info-container {
      color: #616266;

      h1 {
        padding-bottom: 10px;
        font-size: 24px;
      }

      .info-content {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 0 15px 0 15px;
        // border-top: 1px solid rgba(0, 0, 0, 0.1);
        color: #91939a;
        font-size: 14px;

        .label {
          display: block;
          // margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #616266;
        }
      }
    }

    .right-col {
      margin-left: 30px;
      width: 280px;
      //padding:0 0 0 15px;
      .renew_list{
        margin-bottom: 20px;
        p{
          align-items: center;
          cursor: pointer;
          margin-bottom: 10px;
          .icon{
            width: 22px;
            height: 22px;
            background: #E1E4E8;
            border-radius: 5px;
          }
          .money{
            color: #0366D6;
            font-weight: 400;
            font-size: 16px;
          }
          .amount_tag{
            padding: 3px 12px;
            border-radius: 100px;
            font-weight: 600;
            font-size: 12px;
            font-family: 'Inter';
            font-style: normal;
            margin-left: 15px;
            background: #FFFFFF;
            white-space: nowrap;
          }
          .tag_auto{
            border: 1px solid #0366D6;
            color: #0366D6;
          }
          .tag_terms{
            border: 1px solid #E1E4E8;
            color: #586069;
          }
          .active{
            font-weight: 600;
            font-size: 20px;
            color: #24292E;
          }
        }
        .cursor_default{
          cursor: default;
        }
        .btn{
          .el-button{
            flex: 1;
          }
        }
      }
      .icon{
        margin-right: 15px;
        img{
          height: 22px;
          width: 22px;
        }
      }
      .icon-content{
        height: 22px;
        width: 22px;
        border-radius: 5px;
        background-color: #E1E4E8;
        color: #6A737D;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
      }
      .box-remark{
        border-bottom: 0!important;
      }
      .box{
        padding: 29.5px 0;
        border-bottom: 1px solid #D1D5DA;
        .status{
          color: #68C23A
        }
      }
      .plan-name{
        color: #0366D6;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
      }

      .button-weight{
        color: #24292E;
        font-family: Inter;
        //font-size: 14px;
        font-weight: 500!important;
        //padding: 6.5px 17px;
        padding: 10px 20px;
        .percent{
          padding: 0px 6px;
          background: rgba(27, 31, 35, 0.08);
          border-radius: 100px;
          height: 16px;
          font-weight: 600;
          font-size: 12px;
          color: #586069;
          margin-left: 4px;
        }
      }
      .success{
        color: rgba(255, 255, 255, 1);
        background: rgba(46, 164, 79, 1);
      }
      .tr{
        display: flex;
        .mg-r-8{
          margin-right: 8px !important;
        }
      }
      .blue{
        color: #0366D6;
      }
      .bank-pay{
        margin-bottom: 20px;
      }

      ul {
        margin-top: 15px;
        li {
          display: flex;
          padding: 5px;
          list-style: none;
          color: #606266;
          font-size: 12px;
          line-height: 14px;
          span {
            flex: 1;
            .tag{
              .span-tag{
                display: inline-block;
                border-radius: 100px;
                height: 18px;
                background: #FFFFFF;
                padding: 0px 8px;
                font-weight: 600;
                font-size: 12px;
                line-height: 18px;
                box-sizing: content-box;
                white-space: nowrap;
                margin-bottom: 4px;
                &.verified{
                  border: 1px solid #22863a;
                  color: #22863a;
                }
                &.pending_verify{
                  border: 1px solid #dbab09;
                  color: #dbab09;
                }
                &.not_verify{
                  border: 1px solid #d73a49;
                  color: #d73a49;
                }
                &.unread-uplod{
                  border: 1px solid #f66a0a;
                  color: #c24e00;
                }
                &.professional-status, &.coupon-status, &.discount-status{
                  border: 1px solid #0366d6;
                  color: #0366d6;
                }
                &.green {
                  background: #DCFFE4;
                  color: #28A745;
                  border: none;
                }
                &.orange {
                  background-color:#FFF5B1 ;
                  color:  #B08800;
                  border: none;
                }
                &.red {
                  background: #D73A49;
                  color:#fff;
                  border: none;
                }
              }
            }
          }

          span:first-child {
            font-weight: bold;
          }
        }
        margin-bottom: 15px;
      }
      .span-status{
        border: 1px solid #616266;
        color: #616266;
      }
      .card {
        margin-bottom: 15px;
      }

      .border-b {
        //margin: 10px -15px 0 -15px;
        padding: 0 15px 10px;
        border-radius: 15px;
        border: 1px solid rgba(176, 136, 0, 0.2);

        .title {
          margin-top: 10px;
          margin-bottom: 5px;
        }
      }


      .title {
        display: inline-block;
        margin-bottom: 10px;
        padding-top: 5px;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        color: #24292E;
      }

      .el-input, .el-select {
        margin-bottom: 10px;

        & + .el-button {
          margin-bottom: 10px;
        }
      }
      .button-width{
        .el-button{
          width: 100%;
          font-size: 14px;
        }
      }
      .flex-align-center{
        align-items: center;
      }
      .customer-ava{
        height: 28px;
        width: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DBEDFF;
        margin-right: 10px;
        img{
          width: 100%;
          display: block;
          border-radius: 50%;
        }
      }

      .btn-list {
        .el-button {
          display: block;
          margin: 0 0 5px 0;
        }
      }

      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        //border-top: 1px solid #dddfe7;
      }

      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
    }
  }

  .void-status{
    background-color: #FFE3E6!important;
  }
  .paid-status{
    background-color: #DCFFE4!important;
  }
  .unbuyable-status{
    background-color: #FFFBDD!important;
  }
  .void-color{
    color: #CB2431;
  }
  .mt-10{
    margin-top: 10px;
    display: inline-block;
  }
  .incomplete-status{
    background: #FFFBDD;
  }
  .main-header{
    padding: 20px 88px 0px 88px;
    border-bottom: 1px solid #D1D5DA;
    background-color: #FAFBFC;
    .el-tabs--top{
      margin-top: 0!important;
    }
    ::v-deep .el-tabs__header{
      margin-bottom: 0;
      .el-tabs__item{
        font-weight: 400;
        color: #24292E!important;
        .icon{
          color: #959DA5;
          margin-right: 9px;
        }
        &.is-active{
          font-weight: 600!important;
          .icon{
            color: #24292E!important;
          }
        }
      }
      .el-tabs__active-bar{
        background: #F9826C!important;
        width: 120px;
      }
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
  }
  .pdb-10{
    padding-bottom: 10px;
  }
}
.mg-b-20{
  margin-bottom: 20px;
}
.liter-text{
  color: #6A737D;
  font-size: 12px;
  line-height: 18px;
  &.tag-border{
    border: 1px solid #D1D5DA;
    border-radius: 4px;
    text-align: center;
    line-height: 18px;
  }
}
.detail{
  display: flex;
  flex-direction: column;
}

.table{
  position: relative;
  width: 100%;
  border: 1px solid #D1D5DA;
  border-radius: 8px;
  //margin: 0 20px;
  .tr {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #D1D5DA;
    padding: 12px 15px;
    background: #fff;
    width: 100%;
    &.th{
      background: #F6F8FA;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    span{
      flex: 1;
      display: block;
      font-size: 14px;
      color: #24292E;
      padding-right: 0;
      font-style: normal;
      font-weight: 600;
    }
    &.trans_bg{
      background: transparent!important;
      border-bottom: 0;
    }
  }
  .tr_table:last-of-type{
    .tr{
      border-bottom: 0;
      border-radius: 4px;
      background: transparent;
    }

  }
  .icon{
    position: absolute;
    right: 5px;
    transform: translate(-50%, -50%);
    color: #6B7280;
  }
  .tr_contact{
    font-size: 12px!important;
    margin-top:4px ;
    color: #6A737D!important;
    font-weight: 400!important;
    line-height: 18px;
  }
  .tr_more_detail{
    padding: 12px 15px;
    width: 100%;
    border-bottom: 1px solid #D1D5DA;
    background: #F6F8FA;
    .tr{
      padding: 10px 0!important;
      border-bottom: 0;
      background: #F6F8FA;
    }
  }
  .pd-l-15{
    padding-left:15px ;
  }
  .tr_second,.tr_third{
    padding-left:15px ;
    border-left: 4px solid #D1D5DA;
  }
  .tr_second:first-of-type{
    border-top-left-radius: 4px;
  }
  .tr_second:last-of-type{
    border-bottom-left-radius: 4px;
  }
  .tr_third:last-child{
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .flex{
    display: flex!important;
    align-items: baseline;
  }
  .flex .icon-user{
    width: 25px;
    color: #6A737D;
  }
  .mg-left-15{
    margin-left: -15px;
  }
  .mg-left-30{
    margin-left: -30px;
  }
  .none_border{
    border-bottom: 0;
    padding: 15px;
    background: transparent;
    text-align: center;
    color: #D1D5DA;
  }
}
.color-green{
  color:#22863A;
}
.bg-color-green{
 .box-content{
   color:#22863A;
   background: #DCFFE4!important;
 }
}

</style>
